<div class="flex flex-col bg-surface-50 dark:bg-surface-950 h-full overflow-hidden">
    <div class="flex flex-col gap-3 flex-1 min-h-0 overflow-hidden">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-3 h-full">
            <!-- Clause Bundle list (left panel) -->
            <div class="lg:col-span-3 shadow rounded-base p-3 border flex flex-col gap-3 min-h-0 h-full">
                <div class="flex flex-col gap-2 flex-1 min-h-0">
                    <div class="flex flex-wrap items-center justify-between flex-shrink-0">
                        <div class="text-surface-900 dark:text-surface-0 font-semibold text-lg">{{ 'Clause bundle' |
                            textCase }}</div>
                        <app-button [label]="'Add' | textCase" variant="filled" severity="primary" icon="pi pi-plus"
                            (clicked)="openAddBundleDialog()" class="text-sm" />
                    </div>
                    <div class="overflow-y-auto overflow-x-hidden min-h-0 flex-1">
                        @if (bundlesLoading && bundles.length === 0) {
                        @for (item of [0,1,2,3,4]; track $index) {
                        <div class="w-full h-16 sm:h-20 pt-2">
                            <p-skeleton width="100%" height="90%" />
                        </div>
                        }
                        } @else {
                        @if (!bundles.length) {
                        <div class="flex min-h-full items-center justify-center">
                            <p class="text-center text-sm text-gray-500">{{ 'No clause bundles found' | textCase }}</p>
                        </div>
                        } @else {
                        @for (bundle of bundles; track bundle._id) {
                        <div class="flex flex-row gap-2 border p-3 my-2 justify-between rounded-base items-center cursor-pointer"
                            (click)="selectBundle(bundle)"
                            [ngClass]="{'active-key-point': selectedBundle?._id === bundle._id}">
                            <div class="flex flex-col justify-between gap-1 flex-1 min-w-0">
                                <div class="font-bold text-sm sm:text-base truncate">
                                    {{ bundle.name || 'Loading...' }} ({{ getBundleClauseCount(bundle) }})
                                </div>
                                <div class="text-xs sm:text-sm text-gray-600 truncate">
                                    Last updated on {{ bundle.updatedAt | date:'d MMM yyyy' }}
                                </div>
                            </div>
                            <div (click)="$event.stopPropagation()" class="flex-shrink-0">
                                <app-menu #menu [items]="getBundleMenuOptions(bundle)">
                                    <i class="pi pi-ellipsis-v icon-sm p-0 m-0 cursor-pointer text-gray-600"
                                        (click)="menu.toggle($event)"></i>
                                </app-menu>
                            </div>
                        </div>
                        }
                        }
                        }
                    </div>
                </div>
            </div>

            <!-- Right content: clauses table -->
            <div class="lg:col-span-9 flex flex-col gap-3 min-h-0 h-full">
                @if (bundlesLoading) {
                <div class="flex flex-col gap-4 h-full">
                    @for (item of [0,1,2,3,4]; track $index) {
                    <div class="w-full h-16 sm:h-20">
                        <p-skeleton width="auto" height="100%" />
                    </div>
                    }
                </div>
                } @else {
                @if (!bundles.length) {
                <div class="flex flex-1 items-center justify-center">
                    <p class="text-center text-sm text-gray-500">{{ 'No clause bundles found' | textCase }}</p>
                </div>
                } @else if (selectedBundle) {
                <div class="flex flex-col flex-1 min-h-0 w-full overflow-hidden">
                    <div
                        class="flex flex-col sm:flex-row gap-2 justify-between items-start sm:items-center flex-shrink-0 mb-2">
                        <div class="flex flex-wrap items-center gap-2 w-full">
                            <app-button [label]="'Add clause' | textCase" variant="filled" severity="primary"
                                icon="pi pi-plus" (clicked)="openAddClauseDialog()" class="text-sm" />
                            <div class="flex-1 min-w-[200px] max-w-md">
                                <app-search-bar [placeholder]="'Search by clause name or clause text' | textCase"
                                    [(ngModel)]="searchValue" (searchChange)="onSearchChange()" width="80%" />
                            </div>
                        </div>
                        <div class="flex items-center gap-2">
                            <app-popover #sortOverlay width="12rem">
                                <ng-template #trigger>
                                    <app-button variant="outlined" severity="contrast" icon="pi pi-sort-alt" />
                                </ng-template>
                                <ng-template #body>
                                    <div class="flex flex-col text-sm text-gray-800">
                                        <app-button label="Name" variant="ghost" severity="contrast"
                                            [class]="clauseSortBy === ClauseSortBy.Name ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                            [icon]="clauseSortBy === ClauseSortBy.Name ? 'pi pi-check text-orange-500 text-xs' : ''"
                                            iconPosition="right" (clicked)="setClauseSort(ClauseSortBy.Name)" />
                                        <app-button label="Created date" variant="ghost" severity="contrast"
                                            [class]="clauseSortBy === ClauseSortBy.CreatedAt ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                            [icon]="clauseSortBy === ClauseSortBy.CreatedAt ? 'pi pi-check text-orange-500 text-xs' : ''"
                                            iconPosition="right" (clicked)="setClauseSort(ClauseSortBy.CreatedAt)" />
                                        <app-button label="Usage count" variant="ghost" severity="contrast"
                                            [class]="clauseSortBy === ClauseSortBy.UsageCount ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                            [icon]="clauseSortBy === ClauseSortBy.UsageCount ? 'pi pi-check text-orange-500 text-xs' : ''"
                                            iconPosition="right" (clicked)="setClauseSort(ClauseSortBy.UsageCount)" />
                                    </div>
                                    <hr class="my-2" />
                                    <div class="flex flex-col text-sm text-gray-800">
                                        <app-button label="Ascending" variant="ghost" severity="contrast"
                                            [class]="clauseSortOrder === 1 ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                            [icon]="clauseSortOrder === 1 ? 'pi pi-arrow-down text-orange-500 text-xs' : 'pi pi-arrow-down text-black text-xs'"
                                            iconPosition="right" (clicked)="setSortOrder(1)" />
                                        <app-button label="Descending" variant="ghost" severity="contrast"
                                            [class]="clauseSortOrder === -1 ? 'bg-arena-orange-100 text-black justify-between w-full' : 'justify-between w-full'"
                                            [icon]="clauseSortOrder === -1 ? 'pi pi-arrow-up text-orange-500 text-xs' : 'pi pi-arrow-up text-black text-xs'"
                                            iconPosition="right" (clicked)="setSortOrder(-1)" />
                                    </div>
                                </ng-template>
                            </app-popover>
                            <app-button [label]="'Filter' | textCase" variant="outlined" severity="contrast"
                                icon="pi pi-filter" (clicked)="openFilterDialog()" />
                        </div>
                    </div>

                    @if (selectedClauses.length > 0) {
                    <div class="action-bar mb-2">
                        <div class="action-bar-content">
                            <p class="text-xs sm:text-sm font-medium">
                                {{ selectedClauses.length }} item{{ selectedClauses.length > 1 ? 's' : '' }} selected
                            </p>
                            <div class="action-bar-divider"></div>
                            <app-button [label]="'Edit' | textCase" variant="outlined" icon="pi pi-pencil"
                                (clicked)="openBulkEdit()" severity="contrast" />
                            <app-button [label]="'Download' | textCase" variant="outlined" icon="pi pi-download"
                                (clicked)="downloadSelectedClauses()" severity="contrast" />
                            <div class="action-bar-actions-right">
                                <app-button [label]="'Delink' | textCase" variant="outlined" icon="pi pi-link"
                                    (clicked)="delinkSelectedFromBundle()" severity="danger" />
                                <app-button [label]="'Delete' | textCase" variant="outlined" icon="pi pi-trash"
                                    (clicked)="openDeleteClauseDialog()" severity="danger" />
                            </div>
                        </div>
                    </div>
                    }

                    <div class="flex-1 min-h-0 overflow-hidden flex flex-col">
                        <app-data-table [data]="clauses" [columns]="tableColumns" [dataKey]="'_id'"
                            [config]="tableConfig" [customTemplates]="templatesMap" [externalPagination]="true"
                            [externalFirst]="clauseSkip" [externalTotalRecords]="clausesTotal"
                            (pageChange)="onPageChange($event)" (selectionChange)="onClauseSelectionChange($event)"
                            tableClass="text-sm h-full">
                            <ng-template #clauseNameTemplate let-data>
                                <span class="text-sm block truncate max-w-[200px]" [title]="data.name">{{ data.name
                                    }}</span>
                            </ng-template>
                            <ng-template #sourceTemplate let-data>
                                <span class="text-sm">{{ getSourceLabel(data.source) }}</span>
                            </ng-template>
                            <ng-template #createdByTemplate let-data>
                                <div class="flex items-center gap-2">
                                    <img [src]="data.createdBy | userAvatar" alt="User avatar"
                                        class="w-6 h-6 rounded-full" />
                                    <app-user-name-display [user]="data.createdBy" />
                                </div>
                            </ng-template>
                            <ng-template #createdDateTemplate let-data>
                                <div class="flex items-center gap-1">
                                    <i class="pi pi-calendar text-gray-400 text-xs"></i>
                                    <span class="text-sm">{{ data.createdAt | date:'d MMM yyyy' }}</span>
                                </div>
                            </ng-template>
                            <ng-template #usageCountTemplate let-data>
                                <span class="text-sm">{{ data.usageCount ?? 0 }}</span>
                            </ng-template>
                            <ng-template #actionsTemplate let-data>
                                <div (click)="$event.stopPropagation()">
                                    <app-menu #menu [items]="getClauseMenuOptions(data)">
                                        <i class="pi pi-ellipsis-v icon-sm p-0 m-0 cursor-pointer p-2 hover:bg-gray-100 rounded-full transition-colors"
                                            (click)="menu.toggle($event)"></i>
                                    </app-menu>
                                </div>
                            </ng-template>
                        </app-data-table>
                    </div>
                </div>
                } @else {
                <div class="flex flex-1 items-center justify-center">
                    <p class="text-center text-sm text-gray-500">{{ 'Select a clause bundle' | textCase }}</p>
                </div>
                }
                }
            </div>
        </div>
    </div>
</div>

<!-- Add Bundle Dialog -->
<app-dialog [(visible)]="addBundleDialogVisible" (closed)="addBundleDialogVisible = false"
    class="w-[90vw] max-w-[500px] clause-bundle-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Add clause bundle' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
        <form [formGroup]="bundleForm">
            <div class="flex flex-col gap-1 mb-3">
                <label for="bundleName" class="text-sm sm:text-base">Name <span class="text-danger">*</span></label>
                <input id="bundleName" formControlName="name" placeholder="Enter bundle name"
                    class="w-full border outline-none rounded-base p-2 text-sm sm:text-base" />
                @if (bundleFormControls.name.invalid && (bundleFormControls.name.dirty ||
                bundleFormControls.name.touched)) {
                <span class="text-danger text-xs">Name is required.</span>
                }
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Add" variant="filled" severity="primary" (clicked)="createBundle()"
                [disabled]="bundleForm.invalid" />
        </div>
    </ng-template>
</app-dialog>

<!-- Edit Bundle Dialog -->
<app-dialog [(visible)]="editBundleDialogVisible" (closed)="editBundleDialogVisible = false"
    class="w-[90vw] max-w-[500px] clause-bundle-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Edit clause bundle' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-1 mb-3">
            <label class="text-sm sm:text-base">Name <span class="text-danger">*</span></label>
            <input [(ngModel)]="editedBundleName" placeholder="Enter bundle name"
                class="w-full border outline-none rounded-base p-2 text-sm sm:text-base" />
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Save" variant="filled" severity="primary" (clicked)="updateBundle()" />
        </div>
    </ng-template>
</app-dialog>

<!-- Add / Edit Clause Dialog -->
<app-dialog [(visible)]="addClauseDialogVisible" (closed)="addClauseDialogVisible = false"
    class="w-[576px] clause-bundle-dialog clause-bundle-add-clause-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Add clause' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
        <form [formGroup]="clauseForm">
            @if (selectedBundle) {
            <div class="flex flex-col gap-1 mb-3">
                <label class="text-sm sm:text-base">{{ 'Clause bundle' | textCase }}</label>
                <div class="p-2 border border-gray-300 rounded-base text-sm sm:text-base bg-gray-50">{{
                    selectedBundle.name }}</div>
            </div>
            }
            <div class="flex flex-col gap-1 mb-3">
                <label class="text-sm sm:text-base">Clause name <span class="text-danger">*</span></label>
                <input formControlName="name" placeholder="Enter clause name"
                    class="w-full border outline-none rounded-base p-2 text-sm sm:text-base" />
                @if (clauseFormControls.name.invalid && (clauseFormControls.name.dirty ||
                clauseFormControls.name.touched)) {
                <span class="text-danger text-xs">Name is required.</span>
                }
            </div>
            <div class="flex flex-col gap-1 mb-3">
                <label class="text-sm sm:text-base">Clause text <span class="text-danger">*</span></label>
                <textarea formControlName="text" placeholder="Enter clause text" rows="4"
                    class="w-full border outline-none rounded-base p-2 text-sm sm:text-base"></textarea>
                @if (clauseFormControls.text.invalid && (clauseFormControls.text.dirty ||
                clauseFormControls.text.touched)) {
                <span class="text-danger text-xs">Text is required.</span>
                }
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Save" variant="filled" severity="primary" (clicked)="saveClause()"
                [disabled]="clauseForm.invalid" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="editClauseDialogVisible" (closed)="editClauseDialogVisible = false"
    class="w-[90vw] max-w-[560px] clause-bundle-dialog">
    <ng-template #headerTemplate>
        <h3 class="font-bold text-base sm:text-lg">{{ 'Edit clause' | textCase }}</h3>
    </ng-template>
    <ng-template #bodyTemplate>
        <form [formGroup]="clauseForm">
            @if (selectedBundle) {
            <div class="flex flex-col gap-1 mb-3">
                <label class="text-sm sm:text-base">{{ 'Clause bundle' | textCase }}</label>
                <div class="p-2 border border-gray-300 rounded-base text-sm sm:text-base bg-gray-50">{{
                    selectedBundle.name }}</div>
            </div>
            }
            <div class="flex flex-col gap-1 mb-3">
                <label class="text-sm sm:text-base">Clause name <span class="text-danger">*</span></label>
                <input formControlName="name" placeholder="Enter clause name"
                    class="w-full border outline-none rounded-base p-2 text-sm sm:text-base" />
            </div>
            <div class="flex flex-col gap-1 mb-3">
                <label class="text-sm sm:text-base">Clause text <span class="text-danger">*</span></label>
                <textarea formControlName="text" placeholder="Enter clause text" rows="4"
                    class="w-full border outline-none rounded-base p-2 text-sm sm:text-base"></textarea>
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Save" variant="filled" severity="primary" (clicked)="saveClause()"
                [disabled]="clauseForm.invalid" />
        </div>
    </ng-template>
</app-dialog>

<!-- Bulk Edit Clause Dialog -->
<app-dialog [(visible)]="showBulkEditDialog" (closed)="onBulkEditDialogHide()"
    class="w-[70vw] h-[70vh] flex bulk-edit-dialog-content">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2 pl-4">
            <span class="dialog-title">Edit clauses</span>
            <span class="text-sm text-gray-600">
                ({{ savedClauses.size }}/{{ totalEditingCount }})
            </span>
        </div>
    </ng-template>

    <ng-template #bodyTemplate>
        <div class="h-full flex flex-row justify-between gap-4">
            <div class="h-full w-[40%]">
                <div class="clause-cards-container mb-4">
                    @for (clause of editingClauses; track clause._id; let i = $index) {
                    <div class="clause-card mb-3 p-3 border rounded-base cursor-pointer transition-all bg-white border-gray-200 shadow-sm"
                        [ngClass]="{'selected-card': currentEditIndex === i}" (click)="selectClauseForEdit(i)">
                        <div class="overflow-auto">
                            <div class="font-semibold text-sm mb-2 truncate">
                                {{ clause.name }}
                            </div>
                            <div class="text-xs text-gray-600 truncate">
                                {{ clause.text }}
                            </div>
                        </div>
                        <div>
                            @if (savedClauses.has(i)) {
                            <div class="flex flex-col gap-1 items-center">
                                <i class="pi pi-check-circle text-success"></i>
                                <span class="text-xs text-success">Done</span>
                            </div>
                            } @else if (currentEditIndex === i) {
                            <i class="pi pi-chevron-right font-bold"></i>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>

            <!-- Right Panel - Edit Form -->
            <div class="h-full w-[60%] flex flex-col min-h-0">
                @if (editingClauses[currentEditIndex]) {
                <div class="bulk-edit-form flex flex-col border-2 border-gray-100 rounded-base p-4 h-full min-h-0">
                    <!-- Clause name -->
                    <div class="field flex-shrink-0">
                        <label class="flex text-sm font-medium mb-2">Clause name</label>
                        <textarea [(ngModel)]="editingClauses[currentEditIndex].name"
                            (ngModelChange)="saveClauseInBulkEdit(currentEditIndex)"
                            class="w-full border border-gray-200 px-2 py-3 rounded-xl text-sm outline-none resize-none"
                            rows="1" placeholder="Enter clause name..."></textarea>
                    </div>
                    <!-- Clause text -->
                    <div class="field clause-text-field flex-1 min-h-0 flex flex-col">
                        <div class="flex items-center justify-between mb-2">
                            <div class="flex items-baseline gap-1">
                                <p class="text-sm flex-shrink-0">Clause text</p>
                                @if (bulkEditClauseTextExpanded) {
                                <app-button [icon]="'minimize-2'" variant="ghost" severity="contrast"
                                    [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                                    (clicked)="toggleBulkEditClauseTextExpanded()" />
                                } @else {
                                <app-button [icon]="'maximize-2'" variant="ghost" severity="contrast"
                                    [iconSource]="ICON_SOURCE.LUCIDE" [size]="'sm'" class="p-1.5 rounded"
                                    (clicked)="toggleBulkEditClauseTextExpanded()" />
                                }
                            </div>
                            <div class="flex items-center gap-2">
                                <app-button [icon]="CLAUSE_LIBRARY_ICONS.GENERATE_CLAUSE_TEXT"
                                    [iconSource]="ICON_SOURCE.SVG" [size]="'default'" variant="outlined"
                                    severity="contrast" [pTooltip]="'Generate clause text'" tooltipPosition="top"
                                    (clicked)="generateClauseTextForBulkEdit()" [loading]="bulkEditGenerateLoading" />
                                <app-button [icon]="CLAUSE_LIBRARY_ICONS.REPHRASE_CLAUSE_TEXT"
                                    [iconSource]="ICON_SOURCE.SVG" [size]="'default'" variant="outlined"
                                    severity="contrast" [pTooltip]="'Rephrase clause text'" tooltipPosition="top"
                                    (clicked)="rephraseClauseForBulkEdit()"
                                    [disabled]="!editingClauses[currentEditIndex].text.trim()"
                                    [loading]="bulkEditRephraseLoading" />
                            </div>
                        </div>
                        <div class="relative rounded-lg overflow-hidden"
                            [ngClass]="bulkEditClauseTextExpanded ? 'flex-1 min-h-0' : 'flex-shrink-0'"
                            [style.height]="bulkEditClauseTextExpanded ? null : '7rem'">
                            @if (bulkEditGenerateLoading || bulkEditRephraseLoading) {
                            <div
                                class="absolute inset-0 flex items-start justify-start gap-2 p-3 bg-white/80 z-10 rounded-lg">
                                <app-blob-loader [width]="'1.5rem'" [height]="'1.5rem'"></app-blob-loader>
                                <div class="text-sm italic theme-text">Constructing<span>{{ dots$ | async }}</span>
                                </div>
                            </div>
                            }
                            <textarea [(ngModel)]="editingClauses[currentEditIndex].text"
                                (ngModelChange)="saveClauseInBulkEdit(currentEditIndex)"
                                placeholder="Enter clause text..."
                                class="bulk-edit-clause-textarea w-full h-full p-3 text-sm outline-none resize-none overflow-y-auto placeholder:text-gray-400 focus:border-orange-500 border-0 box-border"></textarea>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="flex items-center gap-2">
                <app-button label="Prev" variant="outlined" icon="pi pi-chevron-left"
                    (clicked)="navigateBulkEditPrevious()" [disabled]="isBulkEditPreviousDisabled" />
                <app-button label="Next" variant="outlined" icon="pi pi-chevron-right"
                    (clicked)="navigateBulkEditNext()" [disabled]="isBulkEditNextDisabled" />
            </div>
            <div class="flex gap-2">
                <app-button label="Cancel" variant="outlined" severity="contrast" icon="pi pi-times"
                    (clicked)="onCancelBulkEdit()" />
                <app-button label="Save ({{ savedClauses.size }}/{{ totalEditingCount }})" variant="filled"
                    icon="pi pi-save" (clicked)="onSaveBulkEdit()" [disabled]="isBulkEditSaveDisabled"
                    [loading]="isBulkEditSaving" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Prompt for clause text (bulk edit) -->
<app-dialog [(visible)]="showPromptForClauseDialog" (closed)="closePromptForClauseDialog()" class="max-w-[28rem]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col w-full bg-white rounded-lg">
            <div class="flex items-center justify-between px-4 pt-4 pb-2">
                <span class="text-base font-bold text-gray-800">Prompt for clause text</span>
            </div>
            <div class="px-4 pb-4">
                <textarea [(ngModel)]="promptForClauseText" placeholder="Type here"
                    class="w-full min-h-[8rem] p-3 border border-gray-300 rounded-lg text-sm outline-none resize-none placeholder:text-gray-400 focus:border-orange-500"></textarea>
                <div class="flex justify-end mt-3">
                    <app-button label="Submit" variant="filled" severity="primary"
                        (clicked)="submitPromptForBulkEditClause()" [loading]="bulkEditGenerateLoading" />
                </div>
            </div>
        </div>
    </ng-template>
</app-dialog>

<p-confirmDialog></p-confirmDialog>

<!-- Filter Drawer (same as clause-library) -->
@if (filterDialog) {
<p-drawer [(visible)]="filterDialog" position="right">
    <ng-template pTemplate="headless">
        <div class="flex items-center justify-between p-4 flex-shrink-0 border-b">
            <span class="text-lg font-semibold">{{ 'Filter' | textCase }}</span>
            <div class="flex gap-2 items-center">
                <i class="pi pi-times cursor-pointer" (click)="filterDialog=false"></i>
            </div>
        </div>
        <div class="flex flex-col h-full justify-between">
            <div class="p-4 gap-y-4 flex flex-col overflow-y-auto">
                <!-- Source Multi-select -->
                <div>
                    <div class="text-sm font-semibold mb-2">Source</div>
                    <app-multi-select [options]="sourceFilterOptions" [(value)]="selectedSources" optionLabel="name"
                        optionValue="value" [config]="{placeholder: 'Select source', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>

                <!-- Created By Multi-select -->
                <div>
                    <div class="text-sm font-semibold mb-2">Created by</div>
                    <app-multi-select [options]="userOptions" [(value)]="selectedCreators" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select creators', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>

                <!-- Created Date Range -->
                <div>
                    <div class="text-sm font-semibold mb-2">Created date</div>
                    <app-datepicker [(value)]="selectedDateRange" (onChange)="onDateRangeChange()" [config]="{
                        selectionMode: 'range',
                        placeholder: 'Select date range',
                        styleClass: 'w-full',
                        showButtonBar: false,
                        showIcon: true,
                        appendTo: 'body',
                        maxDate: currentDate
                    }">
                    </app-datepicker>

                    <!-- Date Range Chips -->
                    <div class="flex items-center gap-2 mt-2">
                        <app-button label="Today" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('today') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('today')" />
                        <app-button label="Last 7 days" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('last7days') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('last7days')" />
                        <app-button label="Last 30 days" variant="ghost" severity="contrast"
                            [class]="getDateChipClass('last30days') + ' px-3 py-1.5 text-xs font-medium rounded-base transition-colors'"
                            (clicked)="selectDateRange('last30days')" />
                    </div>
                </div>

                <!-- Usage Count -->
                <div>
                    <div class="text-sm font-semibold mb-2">Usage count</div>
                    <div class="flex items-center gap-2">
                        <div class="flex-1">
                            <input type="number" [(ngModel)]="minUsageCount" [min]="0" placeholder="Min"
                                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm text-gray-700 outline-none focus:border-orange-500" />
                        </div>
                        <div class="flex-1">
                            <input type="number" [(ngModel)]="maxUsageCount" [min]="minUsageCount || 0"
                                placeholder="Max"
                                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm text-gray-700 outline-none focus:border-orange-500" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer Actions -->
            <div class="p-4 flex gap-2 border-t border-gray-200">
                <div class="flex-1 min-w-0">
                    <app-button [label]="'Clear all' | textCase" variant="outlined" severity="contrast"
                        (clicked)="clearFilter()" [fullWidth]="true" />
                </div>
                <div class="flex-1 min-w-0">
                    <app-button [label]="'Apply filter' | textCase" variant="filled" severity="primary"
                        (clicked)="applyFilter()" [enableThrottle]="true" [fullWidth]="true" />
                </div>
            </div>
        </div>
    </ng-template>
</p-drawer>
}

@if (showDeleteBundleDialog) {
<app-delete-confirmation [(visible)]="showDeleteBundleDialog"
    [headerText]="'Delete \'' + (selectedBundle?.name ?? '') + '\'?'"
    bodyText="This clause bundle will be permanently deleted. Clauses in this bundle will be unlinked from it."
    confirmButtonText="Yes, delete" (onConfirm)="deleteBundle()">
</app-delete-confirmation>
}

@if (showDeleteClauseDialog) {
<app-delete-confirmation [(visible)]="showDeleteClauseDialog"
    [headerText]="deleteClauseIds.length > 1 ? 'Delete selected clauses?' : 'Delete clause?'"
    [bodyText]="deleteClauseIds.length > 1 ? 'Selected clauses will be permanently deleted.' : 'This clause will be permanently deleted.'"
    confirmButtonText="Yes, delete" (onConfirm)="deleteClauses()">
</app-delete-confirmation>
}